/**
 * tabs theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/react%403.0.0/packages/react/src/theme/recipes/tabs.ts
 */
import { defineSlotRecipe } from '@chakra-ui/react';
import { tabsAnatomy } from '@chakra-ui/react/anatomy';
export const tabs = defineSlotRecipe({
    slots: tabsAnatomy.keys(),
    base: {},
    variants: {
        variant: {
            line: {
                list: {
                    borderColor: 'transparent',
                },
                trigger: {
                    color: 'text.default',
                    _selected: {
                        color: 'secondary.persianBlue',
                        _horizontal: {
                            '--indicator-color': 'colors.secondary.persianBlue',
                        },
                    },
                },
            },
            chart: {
                root: {
                    rounded: 8,
                    border: '2px solid {colors.black}',
                },
                list: {
                    padding: 0,
                },
                trigger: {
                    rounded: 4,
                    color: 'text.default',
                    bg: 'background.offWhite',
                    textStyle: 'body2',
                    _selected: {
                        color: 'background.offWhite',
                        bg: 'secondary.persianBlue',
                        textStyle: 'body2Bold',
                    },
                },
            },
        },
        size: {
            md: {
                trigger: {
                    textStyle: 'body2',
                    _selected: {
                        textStyle: 'body2Bold',
                    },
                },
            },
        },
    },
    compoundVariants: [],
    defaultVariants: {
        variant: 'line',
    },
});
